import React from 'react';
import { useRouteError, Link } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-white px-3">
            <div className="text-center" style={{ maxWidth: '480px' }}>
                <div className="mb-4">
                    {/* Placeholder for illustration since image gen failed */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="#e2e8f0" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>

                <h1 className="fw-bold mb-3 text-dark">Something went wrong</h1>
                <p className="text-muted mb-4 fs-5">
                    We encountered an unexpected error. Please try again or return home.
                </p>

                {error && (
                    <div className="alert alert-light border mb-4 text-start font-monospace small text-muted p-3 bg-light rounded-3">
                        {error.statusText || error.message || "Unknown Application Error"}
                    </div>
                )}

                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-outline-secondary rounded-pill px-4 py-2"
                        style={{ minWidth: '140px' }}
                    >
                        Try Again
                    </button>
                    <Link
                        to="/"
                        className="btn btn-primary rounded-pill px-4 py-2 text-white border-0"
                        style={{ backgroundColor: '#139956', minWidth: '140px' }}
                    >
                        Return Home
                    </Link>
                </div>
            </div>
        </div>
    );
}